import { render, staticRenderFns } from "./steelSmallFile.vue?vue&type=template&id=37001346&scoped=true"
import script from "./steelSmallFile.vue?vue&type=script&lang=js"
export * from "./steelSmallFile.vue?vue&type=script&lang=js"
import style0 from "./steelSmallFile.vue?vue&type=style&index=0&id=37001346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37001346",
  null
  
)

export default component.exports